import { aosAnimation } from "./modules/aos";
import { lazyLoad } from "./modules/lazy-load";
import { parallax } from "./modules/simple-parallax";
import { vanillaSticky } from "./modules/sticky-elements";
import { PageHeader } from './modules/page-header';
import { MicroModalClass } from './modules/micro-modal';
import { HeaderMenu } from './modules/header-menu';
import { BackToTop } from "./modules/back-to-top";
import { ScrollTo } from "./modules/scroll-to";

jQuery(() => {
  aosAnimation();
  lazyLoad();
  parallax();
  vanillaSticky();
  new PageHeader();
  new HeaderMenu();
  new MicroModalClass();
  new BackToTop();
  new ScrollTo();
});
